 <!-- Search prompt/marquee -->
 <div class="marquee" [ngClass]="marginStyle">
    <h1 class="marquee-heading">{{labelNoFoundTranslate.heading | translate}}</h1>
    <h2 class="marquee-message">{{labelNoFoundTranslate.message | translate}}</h2>
  </div>
